var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMobileOfficeFilterSelected(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.247,
    height: 12.17,
    viewBox: "0 0 17.247 12.17",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon",
    transform: "translate(-3318.521 -9.951)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon-2",
    "data-name": "Icon"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10",
    "data-name": "Group 10",
    transform: "translate(3319.021 10.451)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Fill_1",
    "data-name": "Fill 1",
    d: "M1.516,3.046a1.523,1.523,0,1,1,1.53-1.522,1.544,1.544,0,0,1-1.53,1.522",
    transform: "translate(2.031 8.123)",
    fill: "#ffff",
    stroke: "rgba(0,0,0,0)",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Combined_Shape",
    "data-name": "Combined Shape",
    d: "M1.313,9.14H1.3A1.337,1.337,0,0,1,0,7.766V1.373A1.337,1.337,0,0,1,1.3,0H10.22a1.23,1.23,0,0,1,.707.224.434.434,0,0,1,.094.061l4.636,3.942a1.392,1.392,0,0,1,.589,1.151V7.766a1.341,1.341,0,0,1-1.1,1.354,2.136,2.136,0,0,0-2.228-2.056,2.147,2.147,0,0,0-2.208,2.073H5.75A2,2,0,0,0,5.1,7.665a2.307,2.307,0,0,0-1.583-.6A2.147,2.147,0,0,0,1.313,9.139Zm8.845-8.115H8.823V4.478H14.2Z",
    transform: "translate(0 0)",
    fill: "#ffff",
    stroke: "rgba(0,0,0,0)",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_6",
    "data-name": "Fill 6",
    d: "M1.516,3.046a1.523,1.523,0,1,1,1.53-1.522,1.544,1.544,0,0,1-1.53,1.522",
    transform: "translate(11.469 8.123)",
    fill: "#ffff",
    stroke: "rgba(0,0,0,0)",
    strokeWidth: 1
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobileOfficeFilterSelected);
export default __webpack_public_path__ + "static/media/mobile_office_filter_selected.f43b7351780f536a5b9aa92d7f4c87af.svg";
export { ForwardRef as ReactComponent };